import { render, staticRenderFns } from "./recoverChangePassword.vue?vue&type=template&id=271b3732&scoped=true&"
import script from "./recoverChangePassword.js?vue&type=script&lang=js&"
export * from "./recoverChangePassword.js?vue&type=script&lang=js&"
import style0 from "./recoverChangePassword.vue?vue&type=style&index=0&id=271b3732&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271b3732",
  null
  
)

export default component.exports